import { AuthenticationScheme } from '@see-power-pft-common-js/auth/enums';
import { JwtTokens } from 'common-react/auth/types';
import { HTTP_STATUS } from 'common-react/constants/http-status';
import { Log, User, UserManager, WebStorageStateStore } from 'oidc-client-ts';

const environment = import.meta.env.VITE_ENVIRONMENT;

Log.setLogger(console);
Log.setLevel(environment === 'dev' ? Log.INFO : Log.NONE);

export const getUserManager = () =>
  new UserManager({
    authority: `${import.meta.env.VITE_AUTH_OIDC_AUTHORITY}`,
    client_id: `${import.meta.env.VITE_AUTH_OIDC_CLIENT_ID}`,
    redirect_uri: `${import.meta.env.VITE_AUTH_OIDC_REDIRECT_URI}`,
    silent_redirect_uri: `${import.meta.env.VITE_AUTH_OIDC_REDIRECT_URI}`,
    post_logout_redirect_uri: `${import.meta.env.VITE_AUTH_OIDC_REDIRECT_URI}`,
    response_type: 'code',
    scope: `openid profile email offline_access`,
    response_mode: 'query',
    automaticSilentRenew: true,
    userStore: new WebStorageStateStore({ store: window.localStorage }),
  });

export const getJwtTokensFromOidcUser = (
  user: User | undefined,
): JwtTokens | undefined =>
  user
    ? {
        idToken: user.id_token,
        accessToken: user.access_token,
        refreshToken: user.refresh_token,
      }
    : undefined;

export const getSimaasSchemeAuthenticationJwtTokenUsingAccessToken = async (
  accessToken: string,
  refreshToken: string,
) => {
  try {
    const response = await fetch(
      `${import.meta.env.VITE_PLUTO_API_ENDPOINT}/authentication/token`,
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          scheme: AuthenticationScheme.DEPSSO,
          'access-token': accessToken,
          'refresh-token': refreshToken,
        }),
      },
    );
    if (response.status === HTTP_STATUS.UNAUTHORIZED) {
      return;
    }

    if (response.ok) {
      return await response.text();
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);

    return;
  }
};
